
/* Le Journal : édition du jour (sommaire), sommaire de l'article qui suit la lecture (temps restant), état des
   restaurants à l'heure de Paris (soirs de match à Lens compris), prochain match à Bollaert (guide), fin rouge. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function q(s, r){ return (r || document).querySelector(s); }
  function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
  var TZ = 'Europe/Paris';
  function fmt(o){ try { return new Intl.DateTimeFormat('fr-FR', Object.assign({timeZone: TZ}, o)); } catch(e){ return null; } }

  /* ---- Sommaire du Journal : l'édition du jour ---- */
  var ed = q('[data-edition]');
  if (ed){
    var f = fmt({weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'});
    if (f) ed.textContent = 'Édition du ' + f.format(new Date());
  }

  /* ---- Article : le sommaire suit la lecture ---- */
  var toc = q('[data-toc]'), prose = q('[data-prose]');
  if (toc && prose){
    var links = qa('a[href^="#"]', toc), heads = links.map(function(a){ return document.getElementById(a.getAttribute('href').slice(1)); });
    var list = q('ol', toc), left = q('[data-left]', toc), total = +toc.getAttribute('data-min') || 0;
    var wide = window.matchMedia ? matchMedia('(min-width: 1101px)') : {matches: true};
    var setOpen = function(){ if (wide.matches) toc.setAttribute('open', ''); else toc.removeAttribute('open'); };
    setOpen(); if (wide.addEventListener) wide.addEventListener('change', setOpen);
    q('summary', toc).addEventListener('click', function(e){ if (wide.matches) e.preventDefault(); });
    links.forEach(function(a){ a.addEventListener('click', function(){ if (!wide.matches) toc.removeAttribute('open'); }); });
    var ticking = false;
    var paint = function(){
      ticking = false;
      var r = prose.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = Math.max(0, Math.min(1, (vh * .35 - r.top) / Math.max(1, r.height - vh * .5)));
      list.style.setProperty('--rp', p.toFixed(3));
      var on = -1;
      heads.forEach(function(h, i){ if (h && h.getBoundingClientRect().top < vh * .3) on = i; });
      links.forEach(function(a, i){ a.classList.toggle('is-on', i === on); if (i === on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      if (left && total){
        var m = Math.ceil(total * (1 - p));
        left.textContent = p >= .98 ? 'Lu' : (p < .02 ? total + ' min' : 'Encore ' + m + ' min');
      }
    };
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(paint); } }, {passive: true});
    window.addEventListener('resize', paint);
    paint();
  }

  /* ---- État des restaurants, à l'heure de Paris ---- */
  var hm = fmt({hour: '2-digit', minute: '2-digit', hourCycle: 'h23'});
  function minutes(){
    var d = new Date();
    if (hm){ var p = {}; hm.formatToParts(d).forEach(function(x){ p[x.type] = x.value; }); return +p.hour * 60 + +p.minute; }
    return d.getHours() * 60 + d.getMinutes();
  }
  function label(c){ c = c % 1440; return c === 0 ? 'minuit' : Math.floor(c / 60) + 'h' + (c % 60 ? ('0' + c % 60).slice(-2) : ''); }
  function state(key){
    var t = minutes(), open = window.woodysOpen ? woodysOpen(key) : 690, close = 1380, late = (key === 'lens' && window.woodysLate) ? window.woodysLate() : null;
    if (late && late.yesterday && t < late.yesterday - 1440){ var e = late.yesterday - 1440; return {c: e - t <= 30 ? 'is-soon' : 'is-open', txt: (e - t <= 30 ? 'Ferme bientôt · ' : 'Ouvert · jusqu’à ') + label(late.yesterday)}; }
    if (late && late.today) close = late.today;
    if (t >= open && t < close) return {c: close - t <= 30 ? 'is-soon' : 'is-open', txt: (close - t <= 30 ? 'Ferme bientôt · ' : 'Ouvert · jusqu’à ') + label(close)};
    return {c: 'is-closed', txt: t < open ? 'Fermé · ouvre à ' + label(open) : 'Fermé · ouvre demain ' + label(window.woodysOpen ? woodysOpen(key, 1) : 690)};
  }
  var restos = qa('[data-resto]');
  if (restos.length){
    var paintStates = function(){
      restos.forEach(function(card){
        var s = state(card.getAttribute('data-resto')), el = q('[data-state]', card), tx = q('[data-state-t]', el);
        el.classList.remove('is-open', 'is-soon', 'is-closed'); el.classList.add(s.c);
        if (tx.textContent !== s.txt) tx.textContent = s.txt;
      });
    };
    paintStates(); setInterval(paintStates, 60000);
  }

  /* ---- Guide du match : le prochain match à Bollaert, heure par heure ---- */
  var nx = q('[data-next]'), cal = q('#jr-cal');
  if (nx && cal){
    var all = []; try { all = JSON.parse(cal.textContent); } catch(e){}
    var now = Date.now(), m = null;
    for (var i = 0; i < all.length; i++){ if (Date.parse(all[i].ko) + 105 * 60000 > now){ m = all[i]; break; } }
    if (!m){ nx.hidden = true; }
    else {
      var ko = Date.parse(m.ko), day = fmt({weekday: 'long', day: 'numeric', month: 'long'}), hh = fmt({hour: '2-digit', minute: '2-digit', hourCycle: 'h23'});
      var at = function(off){ var s = hh.format(new Date(ko + off * 60000)).replace(':', 'h'); return s.replace(/h00$/, 'h'); };
      var sameDay = fmt({year: 'numeric', month: '2-digit', day: '2-digit'});
      var tonight = sameDay && sameDay.format(new Date(ko)) === sameDay.format(new Date());
      q('[data-next-t]', nx).textContent = 'Lens – ' + m.opp;
      q('[data-next-w]', nx).textContent = m.comp + ' · ' + (tonight ? 'ce soir' : day.format(new Date(ko))) + (m.ok ? ' à ' + m.h : ' · horaire à confirmer');
      qa('[data-off]', nx).forEach(function(li){
        var off = +li.getAttribute('data-off'), b = q('b', li);
        b.textContent = m.ok ? at(off) : (off === 0 ? 'Coup d’envoi' : (off < 0 ? (-off >= 60 ? Math.floor(-off / 60) + 'h' + ((-off % 60) ? ('0' + (-off % 60)).slice(-2) : '') : -off + ' min') + ' avant' : ''));
      });
      var cl = q('[data-next-close]', nx);
      if (cl) cl.textContent = m.late ? 'Ce soir-là, Woody’s Lens reste ouvert jusqu’à ' + m.close + '.' : 'Woody’s Lens est ouvert jusqu’à 23h.';
      nx.hidden = false;
    }
  }

  /* ---- Fin rouge : le burger arrive du coin ---- */
  var end = q('[data-end]');
  if (end){
    end.classList.add('js');
    if (!reduce && 'IntersectionObserver' in window){ var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ end.classList.add('in'); io.disconnect(); } }); }, {threshold: .25}); io.observe(end); }
    else end.classList.add('in');
  }
})();

